/** React Query key for the public Issue Report offer (FR-201), shared by every reader. */
export const issueReportOfferKeys = {
  all: ['issue-report-offer'] as const,
};
